import translationsData from '../data/translations.json';

export const translations = translationsData;

export function useTranslation(language) {
  const t = (key, fallback) => {
    const keys = key.split('.');
    let value = translations[language];

    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return fallback || key;
      }
    }

    return value || fallback || key;
  };

  return { t };
}
